<template>
  <div class="home-page">
      <Banner :bannerUrl="bannerUrl" :title="bannerTitle" :text="bannerText" />
      <div class="container">
        <module :title="$t('homePage.groupIntro')">
          <div class="company-brief">{{ $t('homePage.groupIntroText') }}</div>
        </module>
        <module :title="$t('homePage.serviceIntro')">
          <businessIntro />
        </module>
        <module :title="$t('homePage.newsCenter')">
          <newsCenter :showMore="true" :limit="true" />
        </module>
      </div>
  </div>
</template>

<script setup>
  import Banner from '@/components/banner'
  import module from './components/module.vue'
  import businessIntro from './components/businessIntro.vue'
  import newsCenter from '@/components/newsList/index.vue'
  import { useI18n } from 'vue-i18n'; 
  const { t } = useI18n();
  const bannerUrl = require('@assets/images/banner.png');
  const bannerTitle = t('homePage.bannerTitle');
  const bannerText = t('homePage.bannerText');
</script>

<style lang="less" scoped>
.home-page {
  .company-brief {
    max-width: 989px;
    color: #25283E;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
  .home-module:last-child {
    margin-bottom: 193px;
  }
  
}
</style>